import React from 'react';
import { Page } from '../Common/Components/Page';
import { AreaManagementContent } from './Components/AreaManagementContent';

export const AreaManagement = (): React.JSX.Element => (
  <Page title="Areas" accessKey={'nodes'} isSearchable={false}>
    <AreaManagementContent />
  </Page>
);
